/**
 * Convert Firebase Auth error codes to user-friendly messages
 */
export const getAuthErrorMessage = (error: any): string => {
  if (!error?.code) {
    return 'An unexpected error occurred. Please try again.'
  }

  const errorCode = error.code as string

  // Firebase Auth error codes
  const errorMessages: Record<string, string> = {
    // Sign in errors
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/user-disabled': 'This account has been disabled.',
    'auth/user-not-found': 'No account found with this email.',
    'auth/wrong-password': 'Incorrect password. Please try again.',
    'auth/invalid-credential': 'Invalid email or password.',
    'auth/too-many-requests':
      'Too many failed attempts. Please try again later.',

    // Sign up errors
    'auth/email-already-in-use':
      'An account with this email already exists. Try signing in instead.',
    'auth/weak-password': 'Password should be at least 6 characters.',
    'auth/operation-not-allowed': 'Email/password accounts are not enabled.',

    // Network errors
    'auth/network-request-failed':
      'Network error. Please check your connection and try again.',
    'auth/timeout': 'The request timed out. Please try again.',

    // General errors
    'auth/popup-closed-by-user': 'Sign in was cancelled.',
    'auth/cancelled-popup-request': 'Sign in was cancelled.',
  }

  return (
    errorMessages[errorCode] ||
    'An error occurred during authentication. Please try again.'
  )
}
